// extracted by mini-css-extract-plugin
export default {"header":"search_header__rii4C","searchLabel":"search_searchLabel__ZV+w4","title":"search_title__KgZr+","divider":"search_divider__0ypW2"};